import {

    CARGAR_PAISES_UBICACION_SOLICITO,
    CARGAR_PAISES_UBICACION_EXITO,
    CARGAR_PAISES_UBICACION_ERROR,

    CARGAR_CONFIG_PAIS_UBICACION_SOLICITO,
    CARGAR_CONFIG_PAIS_UBICACION_EXITO,
    CARGAR_CONFIG_PAIS_UBICACION_ERROR,

    CARGAR_OPCIONES_UBICACION_SOLICITO,
    CARGAR_OPCIONES_UBICACION_EXITO,
    CARGAR_OPCIONES_UBICACION_ERROR,

    CARGAR_PROVINCIAS_UBICACION_SOLICITO,
    CARGAR_PROVINCIAS_UBICACION_EXITO,
    CARGAR_PROVINCIAS_UBICACION_ERROR,

    CARGAR_DEPARTAMENTOS_UBICACION_SOLICITO,
    CARGAR_DEPARTAMENTOS_UBICACION_EXITO,
    CARGAR_DEPARTAMENTOS_UBICACION_ERROR,

    CARGAR_LOCALIDADES_UBICACION_SOLICITO,
    CARGAR_LOCALIDADES_UBICACION_EXITO,
    CARGAR_LOCALIDADES_UBICACION_ERROR

} from '../types';


const initialState = {


    /*
    ====================================
    NUEVO SISTEMA GENÉRICO
    ====================================
    */


    /*
    Lista de países.

    Ejemplo:

    [
        {
            codigo: 'AR',
            nombre: 'Argentina'
        },
        {
            codigo: 'CL',
            nombre: 'Chile'
        }
    ]
    */

    paises: [],


    /*
    Configuración territorial por país.

    Ejemplo:

    {
        CL: {
            codigo: 'CL',
            nombre: 'Chile',
            niveles: [...]
        },

        ES: {
            codigo: 'ES',
            nombre: 'España',
            niveles: [...]
        }
    }
    */

    configPorPais: {},


    /*
    Opciones territoriales cacheadas.

    La clave contiene:

    país | nivel | padre

    Ejemplos:

    {
        "CL|1|ROOT": [
            ...regiones
        ],

        "CL|2|13": [
            ...provincias de Región Metropolitana
        ],

        "CL|3|131": [
            ...comunas de Santiago
        ],

        "AR|1|ROOT": [
            ...provincias
        ]
    }

    Esto permite que paciente, tutor 1 y
    tutor 2 reutilicen exactamente los
    mismos datos sin repetir GET.
    */

    opciones: {},


    loadingPaises:
        false,


    /*
    Loading de configuración por país.

    {
        CL: true,
        AR: false
    }
    */

    loadingConfigPorPais: {},


    /*
    Loading por consulta territorial.

    Ejemplo:

    {
        "CL|2|13": true
    }
    */

    loadingOpciones: {},


    /*
    ====================================
    LEGACY ARGENTINA
    ====================================

    Se mantiene durante la migración.

    Cuando terminemos de reemplazar todos
    los usos viejos podremos eliminarlo.
    */


    provincias: [],


    /*
    {
        "06": [...departamentos Buenos Aires],
        "14": [...departamentos Córdoba]
    }
    */

    departamentos: {},


    /*
    {
        "06441": [...localidades],
        "14014": [...localidades]
    }
    */

    localidades: {},


    loadingProvincias:
        false,


    loadingDepartamentos: {},

    loadingLocalidades: {},


    /*
    ====================================
    ERROR
    ====================================
    */

    error:
        null

};


export default function ubicacionReducer(
    state = initialState,
    action
) {

    switch (
        action.type
    ) {


        /*
        ====================================
        PAÍSES
        ====================================
        */

        case CARGAR_PAISES_UBICACION_SOLICITO:

            return {

                ...state,

                loadingPaises:
                    true,

                error:
                    null

            };


        case CARGAR_PAISES_UBICACION_EXITO:

            return {

                ...state,

                loadingPaises:
                    false,

                paises:
                    action.payload,

                error:
                    null

            };


        case CARGAR_PAISES_UBICACION_ERROR:

            return {

                ...state,

                loadingPaises:
                    false,

                error:
                    action.payload

            };


        /*
        ====================================
        CONFIGURACIÓN PAÍS
        ====================================
        */

        case CARGAR_CONFIG_PAIS_UBICACION_SOLICITO:

            return {

                ...state,

                loadingConfigPorPais: {

                    ...state
                        .loadingConfigPorPais,

                    [action.payload]:
                        true

                },

                error:
                    null

            };


        case CARGAR_CONFIG_PAIS_UBICACION_EXITO:

            return {

                ...state,

                loadingConfigPorPais: {

                    ...state
                        .loadingConfigPorPais,

                    [action.payload.pais]:
                        false

                },

                configPorPais: {

                    ...state
                        .configPorPais,

                    [action.payload.pais]:
                        action.payload
                            .informacion

                },

                error:
                    null

            };


        case CARGAR_CONFIG_PAIS_UBICACION_ERROR:

            return {

                ...state,

                loadingConfigPorPais: {

                    ...state
                        .loadingConfigPorPais,

                    [action.payload.pais]:
                        false

                },

                error:
                    action.payload.error

            };


        /*
        ====================================
        OPCIONES GENÉRICAS
        ====================================
        */

        case CARGAR_OPCIONES_UBICACION_SOLICITO:

            return {

                ...state,

                loadingOpciones: {

                    ...state
                        .loadingOpciones,

                    [action.payload]:
                        true

                },

                error:
                    null

            };


        case CARGAR_OPCIONES_UBICACION_EXITO:

            return {

                ...state,

                loadingOpciones: {

                    ...state
                        .loadingOpciones,

                    [action.payload.clave]:
                        false

                },

                opciones: {

                    ...state
                        .opciones,

                    [action.payload.clave]:
                        action.payload
                            .informacion

                },

                error:
                    null

            };


        case CARGAR_OPCIONES_UBICACION_ERROR:

            return {

                ...state,

                loadingOpciones: {

                    ...state
                        .loadingOpciones,

                    [action.payload.clave]:
                        false

                },

                error:
                    action.payload.error

            };


        /*
        ====================================
        PROVINCIAS
        LEGACY ARGENTINA
        ====================================
        */

        case CARGAR_PROVINCIAS_UBICACION_SOLICITO:

            return {

                ...state,

                loadingProvincias:
                    true,

                error:
                    null

            };


        case CARGAR_PROVINCIAS_UBICACION_EXITO:

            return {

                ...state,

                loadingProvincias:
                    false,

                provincias:
                    action.payload,

                error:
                    null

            };


        case CARGAR_PROVINCIAS_UBICACION_ERROR:

            return {

                ...state,

                loadingProvincias:
                    false,

                error:
                    action.payload

            };


        /*
        ====================================
        DEPARTAMENTOS
        LEGACY ARGENTINA
        ====================================
        */

        case CARGAR_DEPARTAMENTOS_UBICACION_SOLICITO:

            return {

                ...state,

                loadingDepartamentos: {

                    ...state
                        .loadingDepartamentos,

                    [action.payload]:
                        true

                },

                error:
                    null

            };


        case CARGAR_DEPARTAMENTOS_UBICACION_EXITO:

            return {

                ...state,

                loadingDepartamentos: {

                    ...state
                        .loadingDepartamentos,

                    [action.payload
                        .provincia_id]:
                        false

                },

                departamentos: {

                    ...state
                        .departamentos,

                    [action.payload
                        .provincia_id]:
                        action.payload
                            .informacion

                },

                error:
                    null

            };


        case CARGAR_DEPARTAMENTOS_UBICACION_ERROR:

            return {

                ...state,

                loadingDepartamentos: {

                    ...state
                        .loadingDepartamentos,

                    [action.payload
                        .provincia_id]:
                        false

                },

                error:
                    action.payload.error

            };


        /*
        ====================================
        LOCALIDADES
        LEGACY ARGENTINA
        ====================================
        */

        case CARGAR_LOCALIDADES_UBICACION_SOLICITO:

            return {

                ...state,

                loadingLocalidades: {

                    ...state
                        .loadingLocalidades,

                    [action.payload]:
                        true

                },

                error:
                    null

            };


        case CARGAR_LOCALIDADES_UBICACION_EXITO:

            return {

                ...state,

                loadingLocalidades: {

                    ...state
                        .loadingLocalidades,

                    [action.payload
                        .departamento_id]:
                        false

                },

                localidades: {

                    ...state
                        .localidades,

                    [action.payload
                        .departamento_id]:
                        action.payload
                            .informacion

                },

                error:
                    null

            };


        case CARGAR_LOCALIDADES_UBICACION_ERROR:

            return {

                ...state,

                loadingLocalidades: {

                    ...state
                        .loadingLocalidades,

                    [action.payload
                        .departamento_id]:
                        false

                },

                error:
                    action.payload.error

            };


        /*
        ====================================
        DEFAULT
        ====================================
        */

        default:

            return state;

    }

}